import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { IS_TRUE, LOGIN_STATUS } from 'src/app/config/constants';

@Component({
    selector: 'cbms-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
    buttonLabel: string = '';
    constructor(
        private dataService: DataService,
        private authService: OAuthService,
        private router: Router,
    ) {}

    currentYear = new Date().getFullYear();

    ngOnInit(): void {
        this.buttonLabel = localStorage.getItem(LOGIN_STATUS) === IS_TRUE
            ? 'Go to Home page'
            : 'Return to Login';
        this.dataService.currentTabHasChanged('error');
    }

    logout() {
        this.router.navigate(['/']);
    }
}
